import "./StartOrderPage.css";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim.jsx";
import ObjectMetadata from "../../components/ObjectMetadata/ObjectMetadata.jsx";
import Form from "../../components/Form/Form.jsx";
import SectionTitle from "../../components/SectionTitle/SectionTitle.jsx";
import { useEffect, useState } from "react";
import SubmitResult from "../../components/SubmitResult/SubmitResult.jsx";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner.jsx";
import { useParams, useNavigate } from 'react-router-dom';

const StartOrderPage = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [metadata, setMetadata] = useState({});
  const [numberOfScans, setNumberOfScans] = useState(null);
  const [startAndEndCanvas, setStartAndEndCanvas] = useState(null);
  const [submissionStatus, setSubmissionStatus] = useState("idle");
  const [formData, setFormData] = useState({ email: "", pages: {} });
  const [config, setConfig] = useState({});
  const [formErrorMessage, setFormErrorMessage] = useState(null);

  const { objectId } = useParams();
  const navigate = useNavigate();

  const handleSuccess = (email, pages) => {
    setFormData({ email, pages });
    setSubmissionStatus("success");
  };

  const handleError = (message) => {
    setFormErrorMessage(message);
    setSubmissionStatus("error");
  };

  const getStartAndEndCanvas = (manifest) => {
    const startCanvas = manifest.items[0].id;
    const endCanvas = manifest.items[manifest.items.length - 1].id;
    const start = startCanvas.match(/[^/]+$/)[0];
    const end = endCanvas.match(/[^/]+$/)[0];
    return { start, end };
  };

  useEffect(() => {
    const fetchData = async () => {
      const configUrl =
          process.env.REACT_APP_ENV === "local"
              ? "http://dev-cluster1.onb.ac.at:30518/api/config"
              : "/api/config";

      try {
        const configResponse = await fetch(configUrl);
        if (!configResponse.ok) {
          throw { status: 500, message: "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder.\n" +
                "Sollte es wiederholt zu Problemen kommen, wenden Sie sich bitte an digital@onb.ac.at." };
        }
        const configData = await configResponse.json();
        setConfig(configData);

        const manifestResponse = await fetch(configData["manifest-url"] + objectId);
        if (!manifestResponse.ok) {
          throw { status: manifestResponse.status, message: "Leider ist dieser Link ungültig." };
        }
        const manifestData = await manifestResponse.json();

        if (!manifestData.items?.length || !manifestData.metadata) {
          throw { status: 500, message: "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder.\n" +
                "Sollte es wiederholt zu Problemen kommen, wenden Sie sich bitte an digital@onb.ac.at." };
        }

        setMetadata(manifestData.metadata);
        setNumberOfScans(manifestData.items.length);
        setStartAndEndCanvas(getStartAndEndCanvas(manifestData));
        setDataLoaded(true);

      } catch (error) {
        navigate("/error", {
          state: {
            status:  error.status || 500,
            message: error.message || "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder.\n" +
                "Sollte es wiederholt zu Problemen kommen, wenden Sie sich bitte an digital@onb.ac.at"
          }
        });
      }
    };

    fetchData();
  }, [objectId, navigate]);

  return (
      <>
        <PageTitleSlim title="PDF Download" />
        <section className="container narrow">
          <SectionTitle
              title={
                submissionStatus === "success"
                    ? "Auftrag erfolgreich abgeschickt"
                    : "Auftrag erstellen"
              }
          />
          <div className="section-inner">
            <div className="form-container">
              {dataLoaded ? (
                  <>
                    <h3>Objekt</h3>
                    <ObjectMetadata
                        metadata={metadata}
                        numberOfScans={numberOfScans}
                        startAndEndCanvas={startAndEndCanvas}
                    />
                    <hr />
                    {submissionStatus === "idle" ? (
                        <Form
                            objectId={objectId}
                            onSuccess={handleSuccess}
                            onError={handleError}
                            numberOfScans={numberOfScans}
                            startAndEndCanvas={startAndEndCanvas}
                            config={config}
                        />
                    ) : (
                        <SubmitResult
                            submissionStatus={submissionStatus}
                            formData={formData}
                            errorMessage={formErrorMessage}
                            objectId={objectId}
                        />
                    )}
                  </>
              ) : (
                  <LoadingSpinner />
              )}
            </div>
          </div>
        </section>
      </>
  );
};

export default StartOrderPage;
